import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { IconButton, Box, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import color from './Colors';


interface GraphDataPoint {
  name: string;
  value: number;
}


interface CustomGraphProps {
  graphData: GraphDataPoint[];
  weeksData: string[];
  labels: string[];
  date: string;
  onDateChange: (direction: 'previous' | 'next') => void;
}

const CustomGraph: React.FC<CustomGraphProps> = ({ graphData, weeksData, labels, date, onDateChange }) => {
  return (
    <Box sx={{ backgroundColor:color.firstColor, padding: '20px',maxWidth:'600px', width:'100%', borderRadius: '10px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <IconButton onClick={() => onDateChange('previous')}>
          <ArrowBackIosIcon sx={{ color: 'white' }} />
        </IconButton>
        <Typography variant="h6" sx={{ color: 'white' }}>
          {date}
        </Typography>
        <IconButton onClick={() => onDateChange('next')}>
          <ArrowForwardIosIcon sx={{ color: 'white' }} />
        </IconButton>
      </Box>

      <Box sx={{ height: 250, marginTop: 2, ml: "-15px" }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={graphData}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
            >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={{ fill: 'white' }} />
          <YAxis tick={{ fill: 'white' }} />

          
          <Tooltip
            contentStyle={{
              backgroundColor: color.firstColor,
              border: "solid 1.5px white",
              borderRadius:'4px',
              color: "white",
            }}
          />
          {/* <Line type="monotone" dataKey="value" stroke="#ffffff" fillOpacity={1} fill="url(#colorUv)" dot /> */}
          <Line
                type="monotone"
                dataKey="value"
                stroke="#ffffff"
                strokeWidth={3}
                dot={{ r: 6 }}
              />
        </LineChart>
      </ResponsiveContainer>
      </Box>

    </Box>
  );
};

export default CustomGraph;
